import { parse } from 'tinyduration'

// istanziati dentro Vue, accessibili con this.mixinName()
export default {
    methods:{
        // mixin: function() {
        //     window.console.log('I am a mixin')
        // },
        log: function(value)
        {
            if (process.env.VUE_APP_MODE !== 'development') return
            window.console.log(value)
        }
    }
}

// vanno importati solo se necessario con import { utility, ... } from '@/utilities'
// nel mounted() possono essere richiamati con utility()
// per usarli nel template va fatto il binding: this.utility = utility (nel created() o coumnque prima del mount)
// export function utility()
// {
//     window.console.log('I am an utility')
// }

export function parse_flight_offers_duration(duration)
{
    return parse(duration)
}

export function parse_flight_offers_date(date)
{
    let split = date.split('T')
    return {
        day: split[0],
        hour: split[1],
    }
}

export function filter_quotes_by(filters,results)
{
    let results_filtered = []
    filters.forEach(filter => {
        if(filter.key == 'status')
        {
            if(filter.value == 'all')
            {
                results_filtered = results
            }
            else
            {
                results_filtered = results.filter(function(r){

                    let val = (r.soldquote_status)? r.soldquote_status : r.request_status

                    return val == filter.value

                })
            }
        }
    })  
    return results_filtered  
}

export function reverse_date(date){
    // yyyy-mm-dd to dd-mm-yyyy and viceversa
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(date)
    return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('-')
}

export function strip_html_from_string(str)
{
    let regex = /(<([^>]+)>)/ig;
	return str.replace(regex, "");
}

export function wip(str){
    str = str || 'wip'
    window.alert(str)
}